import userAgent from '@/libs/user-agent'

export default {
  data: function () {
    return {
      viewSignup: 0,
      viewVerificationCode: 1,
      viewPassword: 2,
      viewResetPassword: 3,
      viewStart: 4,
      viewPhoneLogin: 5,
      viewPhoneSignup: 6,
      viewPhoneLoginVerificationCode: 7,
      viewPhoneSignupVerificationCode: 8,
      viewLogin: 9,
      viewCreatePassword: 10
    }
  },
  methods: {
    toggleIOS11Fix: function (toggle) {
      if (userAgent.isIOS11()) {
        const body = document.getElementsByTagName('body')
        if (body && body.length > 0) {
          body[0].className = toggle ? 'ios-modal-fix' : ''
        }
      }
    }
  }
}
